import Route from '@ember/routing/route';

export default class LocationOverviewPoliciesIndexRoute extends Route {
  titleToken = 'Policies';
}
